import { HeaderLogo } from "../HeaderLogo";
import { HeaderTitle } from "../HeaderTitle";
import styles from "../Header/styles.module.css";

interface IHeaderProps {
  title: string;
  subtitle?: string;
  rightLogo?: string;
  className?: string;
  countdownProps?: {
    showCountdown?: boolean;
    lastUpdatedAt?: number;
  };
}

export function Header({
  title,
  subtitle = "",
  rightLogo,
  className,
  countdownProps,
}: IHeaderProps) {
  return (
    <header
      className={`${styles.header} ${className ? styles[className] : ""}`}
    >
      <HeaderTitle
        title={title}
        subtitle={subtitle}
        countdownProps={countdownProps}
      />
      <HeaderLogo rightLogo={rightLogo} />
    </header>
  );
}
